import type { TestFunction } from 'yup';

export const isRussianLettersWithNoFirstNumber: TestFunction<string> = (value, context) => {
  const isValid = !value || /^[а-яё][а-яё\-\d\s.,/]+/gi.test(value as string);
  return (
    isValid || context.createError({ message: 'Только кириллица, не должно начинаться с цифры', path: context.path })
  );
};
